export const palette = {
    light: {
        white: '#FFFFFF',
        black: '#000',
        gray: {
            mainDark: '#262D33',
            main: '#1B2025',
            light: '#B6BFC9',
            normal: '#6F6F6F',
            dark: '#383E47',
            veryDark: '#313942',
            mainChatGray: '#AFB3B6',
            mainChatDarkGray: '#364049',
            mainDarkTransparent: 'rgb(38, 45, 51, 0.7)',
        },
        yellow: '#D0BC25',
        yellowOpacity: 'rgba(208, 188, 37, 0.15)',
        orange: '#EA9B58',
        green: '#65CA63',
        blue: '#59B8C9',
        violet: '#9869EF',
        pink: '#DB5BA1',
        red: '#EA4335',
    },
    dark: {},
}
